module.exports = __webpack_public_path__ + "static/media/tomy.16219a89.jpg";